import anime from 'animejs/lib/anime.es.js';
import scrollMonitor from 'scrollmonitor';

const popup = document.querySelector('.popup');
const popupContent = document.querySelector('.popup__content');
const closer = document.querySelector('.popup__closer');
const popupTriggerEl = document.querySelector('[data-popup-trigger]');

// Funzioni
function openModal() {
    anime({
        targets: popup,
        opacity: '1',
        easing: 'easeOutQuad',
        duration: 480,
        begin: function () {
            popup.style.display = 'block';
        },
    });
    anime({
        targets: popupContent,
        translateY: ['32%', '0%'],
        opacity: '1',
        easing: 'easeOutQuad',
        duration: 480,
        delay: 480,
        complete: function () {
            popup.classList.add('popup_open');
        }
    });
}

function closeModal() {
    anime({
        targets: popupContent,
        translateY: '32%',
        opacity: '0',
        easing: 'easeOutQuad',
        duration: 480,
    });
    anime({
        targets: popup,
        opacity: '0',
        easing: 'easeOutQuad',
        duration: 480,
        delay: 480,
        complete: function () {
            popup.style.display = 'none';
        },
    });
}

if (popup !== null) {
    closer.addEventListener('click', function () {
        closeModal();
    });

    document.addEventListener('click', function (event) {
        if (!popupContent.contains(event.target) && popup.classList.contains('popup_open')) {
            closeModal();
        }
    });

    var triggerWatcher = scrollMonitor.create(popupTriggerEl);

    triggerWatcher.partiallyExitViewport(function () {
        openModal();
        setTimeout(() => {
            triggerWatcher.destroy();
        }, 0);
    });
}